import { InvoiceSchema, ZodCreateFirstInvoiceSchema } from "@billingnow/zod-schema";
import { apiClient } from "./client";

export interface FirstInvoiceTurn {
  /** The assistant's reply for this turn — always shown in the chat. */
  message: string;
  /** Set on the turn the invoice is created; null while it's still asking. */
  invoice: InvoiceSchema | null;
}

/**
 * Advance the onboarding first-invoice conversation by one turn (runs before the
 * paywall). Send the whole conversation each time. An invoice can be created
 * only once per organization — later calls return 409.
 */
export const createFirstInvoice = async (data: ZodCreateFirstInvoiceSchema): Promise<FirstInvoiceTurn> => {
  const response = await apiClient.post<FirstInvoiceTurn>("/api/onboarding/first-invoice", data);
  return response.data;
};
